import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

// Event BUS
export const bus = new Vue();

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax);

// modals
import VModal from 'vue-js-modal'
Vue.use(VModal, { componentName: 'modal' })

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

axios.interceptors.response.use(
    function(successRes) {
        // console.log('axios response success');
        return successRes;
    },
    function(error) {
        // document.location.reload();
        return Promise.reject(error);
    });




// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
import { localize } from 'vee-validate'
import { Validator } from 'vee-validate';
import attributesEs from 'vee-validate/dist/locale/es'

Validator.localize('es', attributesEs);
// Vue.use(VeeValidate)
// VeeValidate Locale - Validation Localte
Vue.use(VeeValidate, {
    locale: 'es',
    dictionary: {
        translationsEs: { attributes: attributesEs }
    }
});

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_KEY',
        libraries: 'places' // This is required if you use the Auto complete plug-in
    }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
// import './registerServiceWorker'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

window.OneSignal = window.OneSignal || [];

Vue.prototype.OneSignal = window.OneSignal;
Vue.prototype.plugins = window.plugins;


window.OneSignal.push(() => {
    window.OneSignal.init({
        appId: '334716ad-6d47-4ee8-9373-d268501d4ffc',
        allowLocalhostAsSecureOrigin: true,
        subdomainName: "evolugy",
        promptOptions: {
            slidedown: {
                enabled: true,
                autoPrompt: true,
                timeDelay: 10,
                // pageViews: 2, 
                actionMessage: "Deseas que te notifiquemos sobre eventos importantes de tu cuenta en Evolugy?",
                /* acceptButtonText limited to 15 characters */
                acceptButtonText: "Permitir",
                /* cancelButtonText limited to 15 characters */
                cancelButtonText: "NO Permitir",
            }
        },
        welcomeNotification: {
            "title": "My Custom Title",
            "message": "Thanks for subscribing!",
            // "url": "" /* Leave commented for the notification to not open a window on Chrome and Firefox (on Safari, it opens to your webpage) */
        }
    });

    window.OneSignal.on('subscriptionChange', function(isSubscribed) {
        // store.dispatch('updateUserOSPlayerId');
        console.log("The user's subscription state is now:", isSubscribed);


    });
    OneSignal.on('notificationPermissionChange', function(permissionChange) {
        var currentPermission = permissionChange.to;
        // store.dispatch('updateUserOSPlayerId');
        console.log('New permission state:', currentPermission);

    });

});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')